import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['form', 'feedbackContent', 'dropdown'];

  formTargetConnected(form) {
    form.addEventListener('ajax:success', (event) => {
      this.handleSuccessfulSubmit(event.detail[0].html);
    });
  }

  handleSuccessfulSubmit(responseHtml) {
    this.element.innerHTML = responseHtml;
    document.getElementById('ionic-feedback-dialog').dismiss();
  }

  dropdownTargetConnected() {
    this.dropdownTarget.value = '';

    this.dropdownTarget.addEventListener('change', () => {
      this.feedbackContentTarget.classList.remove('hide');
    });
  }
}
